import { Box, Tooltip } from '@mui/material';
import { PartnerPlaceholderImage } from 'assets/img';
import { StyledCell } from 'FeatureModules/Partner/Components/PartnersTable/PartnersTableBody/PartnersTableBody.styles';
import { StyledTableBody, StyledTableRow } from 'Components/TableBase/Table';
import Image from 'DesignSystem/DataDisplay/Image/Image';
import ThemeTypography from 'DesignSystem/Primitives/Typography/ThemeTypography';
import React, { FC, MouseEvent } from 'react';
import { IQuestionnaire } from 'FeatureModules/Questionnaire/types/questionnaire.types';
import { IHeaderColumn } from 'Components/TableBase/SortableTableHead';
import { EQuestionnaireHeaderColumnEnum } from './questionnaireHeaderColumns';
import QuestionnaireTitle from './QuestionnaireTitle';
import Icon from 'DesignSystem/Primitives/Icon/Icon';
import { StyledIconButton } from 'FeatureModules/ImpactClaim/Components/Table/styles';

interface IProps {
  questionnaires: IQuestionnaire[];
  headerColumns: IHeaderColumn[];
  onSelect: (questionnaire: IQuestionnaire) => void;
  onEdit?: (questionnaire: IQuestionnaire) => void;
  onDelete?: (questionnaire: IQuestionnaire) => void;
}

const QuestionnaireTableBody: FC<IProps> = ({
  questionnaires,
  headerColumns,
  onSelect,
  onEdit,
}) => {
  return (
    <StyledTableBody>
      {questionnaires.map((questionnaire, index) => {
        const { id } = questionnaire;
        return (
          <StyledTableRow
            hover
            data-testid="questionnaire-table-row"
            key={`${id}-${index}`}
            onClick={(event: MouseEvent) => {
              event.stopPropagation();
              onSelect(questionnaire);
            }}
          >
            {headerColumns.map(({ id: column, align }) => {
              switch (column) {
                case EQuestionnaireHeaderColumnEnum.TITLE:
                  return (
                    <StyledCell key={column} scope="row" align={align}>
                      <QuestionnaireTitle
                        title={questionnaire.title}
                        year={questionnaire.year}
                        externalId={questionnaire.externalId}
                      />
                    </StyledCell>
                  );

                case EQuestionnaireHeaderColumnEnum.CREATED_BY:
                  return (
                    <StyledCell key={column} scope="row" align={align}>
                      {questionnaire.createdBy && (
                        <Box display="flex" alignItems="center">
                          <Image
                            width={44}
                            height={44}
                            image={questionnaire.createdBy?.logo}
                            backupImageUrl={PartnerPlaceholderImage}
                          />
                          <Box ml={1}>
                            <ThemeTypography variant="ITEM_SUBTITLE">
                              {questionnaire.createdBy?.name}
                            </ThemeTypography>
                          </Box>
                        </Box>
                      )}
                    </StyledCell>
                  );

                // case QuestionnaireHeaderColumnEnum.CREATED_AT:
                //   return (
                //     <StyledCell scope="row" align={align}>
                //       <ThemeTypography variant="BODY_MEDIUM">
                //         <Moment format="MMMM DD, YYYY">{questionnaire.}</Moment>
                //       </ThemeTypography>
                //     </StyledCell>
                //   );

                case EQuestionnaireHeaderColumnEnum.ACTIONS:
                  return (
                    <StyledCell key={column} scope="row" width={150}>
                      <Box display="flex" alignItems="center" justifyContent="flex-end">
                        <Tooltip title="Edit questionnaire">
                          {/* Wrapper to show the tooltip even when disabled */}
                          <Box component="span">
                            <StyledIconButton
                              onClick={event => {
                                event.stopPropagation();
                                onEdit?.(questionnaire);
                              }}
                            >
                              <Icon name="edit" />
                            </StyledIconButton>
                          </Box>
                        </Tooltip>
                      </Box>
                    </StyledCell>
                  );

                default:
                  return null;
              }
            })}
          </StyledTableRow>
        );
      })}
    </StyledTableBody>
  );
};

export default QuestionnaireTableBody;
